import { emptySplitApi as api } from '../../../store/emptyApi';
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        getApiV1UnderwritingPaths: build.query<GetApiV1UnderwritingPathsApiResponse, GetApiV1UnderwritingPathsApiArg>({
            query: () => ({ url: `/api/v1/underwriting/paths` }),
        }),
        postApiV1UnderwritingPaths: build.mutation<
            PostApiV1UnderwritingPathsApiResponse,
            PostApiV1UnderwritingPathsApiArg
        >({
            query: (queryArg) => ({ url: `/api/v1/underwriting/paths`, method: 'POST', body: queryArg }),
        }),
        getApiV1UnderwritingPathsByPathId: build.query<
            GetApiV1UnderwritingPathsByPathIdApiResponse,
            GetApiV1UnderwritingPathsByPathIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/underwriting/paths/${queryArg.pathId}`,
                params: { history: queryArg.history },
            }),
        }),
        postApiV1UnderwritingPathsByPathId: build.mutation<
            PostApiV1UnderwritingPathsByPathIdApiResponse,
            PostApiV1UnderwritingPathsByPathIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/v1/underwriting/paths/${queryArg.pathId}`,
                method: 'POST',
                body: queryArg.path,
            }),
        }),
        deleteApiV1UnderwritingPathsByPathId: build.mutation<
            DeleteApiV1UnderwritingPathsByPathIdApiResponse,
            DeleteApiV1UnderwritingPathsByPathIdApiArg
        >({
            query: (queryArg) => ({ url: `/api/v1/underwriting/paths/${queryArg}`, method: 'DELETE' }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetApiV1UnderwritingPathsApiResponse = /** status 200 Success */ Path[];
export type GetApiV1UnderwritingPathsApiArg = void;
export type PostApiV1UnderwritingPathsApiResponse = /** status 200 Success */ Path;
export type PostApiV1UnderwritingPathsApiArg = Path;
export type GetApiV1UnderwritingPathsByPathIdApiResponse = /** status 200 Success */ Path;
export type GetApiV1UnderwritingPathsByPathIdApiArg = {
    pathId: number;
    history?: number;
};
export type PostApiV1UnderwritingPathsByPathIdApiResponse = /** status 200 Success */ Path;
export type PostApiV1UnderwritingPathsByPathIdApiArg = {
    pathId: number;
    path: Path;
};
export type DeleteApiV1UnderwritingPathsByPathIdApiResponse = unknown;
export type DeleteApiV1UnderwritingPathsByPathIdApiArg = number;
export type PathFilter = {
    filterId?: number;
    filterValues?: string | null;
};
export type PathModel = {
    modelId?: number;
    sortOrder?: number;
};
export type PathType = {
    typeId?: number;
    description?: string;
};
export type Path = {
    pathId?: number;
    pathType: string;
    name?: string | null;
    activeStart: string;
    activeEnd: string;
    isDeleted?: boolean;
    pathFilterModels: PathFilter[];
    pathModels: PathModel[];
};
